<template>
  <div>
    <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="pushList"
    :is-show-store-select="true"
    :is-store-select-clearable="true"
    :is-show-search-input="true"
    :is-show-xls-export-button="true"
    search-placeholder="输入姓名、昵称、手机号或卡号"
    default-order-by="total_hours"
    excel-name="舞者等级活动排名"
    :excel-data="xlsData"
  >
    <template slot="header-item">
      <el-select
        class="table-filter-select"
        v-model="queryList.level_value"
        clearable
        size="small"
        placeholder="等级"
        @change="handleLevelChange"
      >
        <el-option
          v-for="level in rankLevelOptions"
          :key="level.value"
          :label="level.name"
          :value="level.value"
        />      </el-select>
    </template>

    <template slot="summary">
      <div class="activity-summary">
        <span class="activity-title">{{ activity.activity_name || '舞者等级活动' }}</span>
        <span v-if="activity.start_time" class="info-color">
          {{ activity.start_time | timeToYmdHi }} ~ {{ activity.end_time | timeToYmdHi }}
        </span>
        <span v-if="activity.last_refresh_time" class="refresh-time info-color">
          上次刷新：{{ activity.last_refresh_time | timeToYmdHi }}
        </span>
        <span v-else class="refresh-time info-color">尚未刷新</span>
        <el-button
          v-if="isAdministrator"
          size="small"
          type="warning"
          :loading="isRefreshing"
          @click="handleRefresh"
        >
          刷新排名
        </el-button>
        <el-button
          v-if="isAdministrator"
          size="small"
          type="primary"
          :loading="isPreviewing"
          @click="handleIssuePreview"
        >
          发放代金券
        </el-button>
      </div>

      <div v-if="levelCounts.length" class="level-counts">
        <span
          v-for="level in levelCounts"
          :key="level.level_id"
          class="level-count-item"
          :class="{ 'level-count-active': queryList.level_value === level.level_id }"
          @click="handleLevelCountClick(level)"
        >
          <i class="level-dot" :style="{ backgroundColor: level.color }"/>
          <span class="level-count-name">{{ level.level_name }}</span>
          <span class="info-color">{{ level.student_count }} 人 / 待发 {{ level.pending_count }}</span>
        </span>
      </div>
    </template>

    <el-table-column label="排名" width="80">
      <template v-slot="{ $index }">NO.{{ (queryList.page - 1) * (queryList.size || 10) + $index + 1 }}</template>
    </el-table-column>

    <el-table-column label="学员" width="170">
      <template v-slot="{ row }">
        <v-avatar-nickname
          :value="row.selfie"
          :nickname="row.student_name"
          :link-page-name="RouteConfig.studentDetail.name"
          :link-page-id="row.student_id"
        />
      </template>
    </el-table-column>

    <el-table-column label="手机号" prop="phone" width="130"/>

    <el-table-column label="会员卡号" prop="card_number" width="130"/>

    <el-table-column label="上课次数" prop="total_hours" sortable="custom" width="110">
      <template v-slot="{ row }">{{ row.total_hours }} 次</template>
    </el-table-column>

    <el-table-column label="等级" width="90">
      <template v-slot="{ row }">
        <span :style="{ color: row.level_color, fontWeight: 600 }">{{ row.level_name || '--' }}</span>
      </template>
    </el-table-column>

    <el-table-column label="最常上课门店" width="200">
      <template v-slot="{ row }">
        <span>{{ row.top_store_name || '--' }}</span>
        <span v-if="row.top_store_hours" class="info-color">（{{ row.top_store_hours }} 次）</span>
      </template>
    </el-table-column>

    <el-table-column label="发券状态" width="210">
      <template v-slot="{ row }">
        <template v-if="row.voucher_issue_time">
          <el-tag size="small" type="success">已发放</el-tag>
          <span class="issue-voucher-name">{{ row.issued_voucher_type_name }}</span>
        </template>
        <span v-else class="info-color">未发放</span>
      </template>
    </el-table-column>

    <v-column-time value="注册时间" field="add_time" sortable=""/>

    <el-table-column label="操作" width="140">
      <template v-slot="{ row }">
        <v-list-button
          name="上课记录"
          icon="view"
          size="large"
          @click="handleViewRecord(row)"
          :is-last="true"
        />
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`student-rank-activity-record-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>排名</span>
              <span>NO.{{ (queryList.page - 1) * (queryList.size || 10) + k + 1 }}</span>
            </div>

            <div class="list-item-detail">
              <span>学员</span>
              <v-avatar-nickname
                :value="v.selfie"
                :nickname="v.student_name"
                :link-page-name="RouteConfig.studentDetail.name"
                :link-page-id="v.student_id"
              />
            </div>

            <div class="list-item-detail">
              <span>上课次数</span>
              <span>{{ v.total_hours }} 次</span>
            </div>

            <div class="list-item-detail">
              <span>等级</span>
              <span :style="{ color: v.level_color }">{{ v.level_name || '--' }}</span>
            </div>

            <div class="list-item-detail">
              <span>最常上课门店</span>
              <span>{{ v.top_store_name || '--' }}（{{ v.top_store_hours }} 次）</span>
            </div>

            <div class="list-item-detail">
              <span>发券状态</span>
              <span v-if="v.voucher_issue_time">{{ v.issued_voucher_type_name }}</span>
              <span v-else>未发放</span>
            </div>

            <div class="list-item-button">
              <v-list-button
                name="上课记录"
                icon="view"
                size="large"
                @click="handleViewRecord(v)"
                :is-last="true"
              />
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>

  <el-dialog
    title="发放代金券确认"
    :visible.sync="isShowIssueDialog"
    width="700px"
  >
    <div v-if="issuePreview" class="issue-preview">
      <p class="issue-summary">
        活动「{{ issuePreview.activity_name }}」待发放学员合计
        <b class="primary-color">{{ issuePreview.total_student_count }}</b> 人：
      </p>

      <el-table class="issue-table" :data="issuePreview.levels" border size="mini">
        <el-table-column label="等级" prop="level_name"/>
        <el-table-column label="发券配置" width="100">
          <template v-slot="{ row }">
            <el-tag v-if="row.is_voucher_configured" size="mini" type="success">发放</el-tag>
            <el-tag v-else size="mini" type="info">不发放</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="代金券类型" prop="voucher_type_name">
          <template v-slot="{ row }">{{ row.voucher_type_name || '--' }}</template>
        </el-table-column>
        <el-table-column label="面额（元）" width="90">
          <template v-slot="{ row }">
            <span v-if="row.amount_in_cents">{{ row.amount_in_cents | toYuan }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="待发放人数" width="90" prop="student_count"/>
        <el-table-column label="过期时间" width="180">
          <template v-slot="{ row }">
            <span v-if="row.is_voucher_configured && row.expire_time">{{ formatExpireTime(row.expire_time) }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
      </el-table>

      <el-alert
        class="issue-warning"
        title="发券后不可撤销，请确认等级数据无误后再继续。"
        type="warning"
        show-icon
        :closable="false"
      />
    </div>

    <template slot="footer">
      <el-button @click="isShowIssueDialog = false">取消</el-button>
      <el-button type="primary" :loading="isIssuing" @click="handleIssueConfirm">确认发放</el-button>
    </template>
    </el-dialog>
  </div>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { getLegalQueryList } from '@/utils/formats';
import { reserveStates } from '@/enums/reserveStates';
import {
  show,
  getRanks,
  refresh,
  getIssueVoucherPreview,
  issueVouchers,
} from '@/api/student-rank-activity';
import { index as indexLevels } from '@/api/student-rank-level';
import { timeToYmd, timeToYmdHi, timeToYmdHis } from '@/filters';

export default {
  name: RouteConfig.studentRankActivityRankList.name,
  data: () => ({
    RouteConfig,
    reserveStates,
    isLoading: false,
    isRefreshing: false,
    isPreviewing: false,
    isIssuing: false,
    isShowIssueDialog: false,
    levels: [],
    activity: {},
    issuePreview: null,
    count: 0,
    list: [],
    xlsData: [],
    levelCounts: [],
    queryList: {
      page: 1,
      size: 10,
      is_asc: 0,
      level_value: '',
      store_id: 0,
      keyword: '',
    },
  }),
  computed: {
    ...mapGetters(['isAdministrator', 'defaultStoreId']),
    rankLevelOptions() {
      return this.levels.map((level) => ({
        value: level.id,
        name: level.level_name,
      }));
    },
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.getLevels();
    this.load();
  },
  methods: {
    getActivityId() {
      return +this.$route.params.id || 0;
    },
    formatExpireTime(time) {
      return timeToYmdHis(time, '--');
    },
    async getLevels() {
      const { isError, data } = await indexLevels({ is_del: 0, size: 200 });
      if (isError) return;

      this.levels = data.list || [];
    },
    async load(route = this.$route) {
      const activityId = this.getActivityId();
      if (!activityId) {
        this.$message.warning('缺少活动 ID，无法加载排名！');
        RouteConfig.studentRankActivityList.push();
        return;
      }

      this.isLoading = true;
      // 与课卡列表一致：非总部管理员默认选中所属门店，超级管理员（总部）不自动选中
      this.queryList.store_id = this.defaultStoreId;
      getLegalQueryList(this.queryList, route.query);
      const [activityResult, ranksResult] = await Promise.all([
        show(activityId),
        getRanks(activityId, this.queryList),
      ]);
      this.isLoading = false;

      const { isError: isActivityError, data: activityData } = activityResult;
      if (!isActivityError && activityData) this.activity = activityData;

      const { isError, data } = ranksResult;
      if (isError) return;

      this.count = data.count || 0;
      this.list = data.list || [];
      this.levelCounts = data.level_counts || [];
      if (data.activity) this.activity = data.activity;
      this.xlsData = this.setXlsData(this.list);
    },
    handleViewRecord(row) {
      const query = {
        start_date: timeToYmd(this.activity.start_time),
        end_date: timeToYmd(this.activity.end_time),
        reserve_state: reserveStates.signedIn.value,
      };
      this.$router.push(RouteConfig.studentDetail.to(row.student_id, query));
    },
    handleLevelChange() {
      this.queryList.page = 1;
      this.pushList(this.queryList);
    },
    handleLevelCountClick(level) {
      // 点击统计条切换等级筛选，再次点击同一等级则取消筛选
      this.queryList.level_value = this.queryList.level_value === level.level_id ? '' : level.level_id;
      this.queryList.page = 1;
      this.pushList(this.queryList);
    },
    pushList(query) {
      // 动态路由需同时携带活动ID与查询参数
      return RouteConfig.studentRankActivityRankList.push(this.getActivityId(), query);
    },
    async handleRefresh() {
      const activityId = this.getActivityId();
      if (!activityId) return;

      const isConfirm = await this.$confirm(
        '将重新统计活动区间内全部学员的上课次数、最常门店与等级，确认继续吗？',
        '刷新排名',
        { confirmButtonText: '开始刷新', cancelButtonText: '取消', type: 'warning' },
      ).catch(() => {});
      if (!isConfirm) return;

      this.isRefreshing = true;
      const { isError, data } = await refresh(activityId);
      this.isRefreshing = false;
      if (isError) return;

      this.$message.success(`刷新完成，共更新 ${data.student_count || 0} 名学员。`);
      this.load();
    },
    async handleIssuePreview() {
      const activityId = this.getActivityId();
      if (!activityId) return;

      this.isPreviewing = true;
      const { isError, data } = await getIssueVoucherPreview(activityId);
      this.isPreviewing = false;
      if (isError) return;

      if (!data.total_student_count) {
        this.$message({
          message: '暂无可发放的学员：要么已全部发放，要么相应等级未配置代金券。',
          type: 'info',
          duration: 5000,
        });
        return;
      }

      this.issuePreview = data;
      this.isShowIssueDialog = true;
    },
    async handleIssueConfirm() {
      const activityId = this.getActivityId();
      if (!activityId || !this.issuePreview) return;

      this.isIssuing = true;
      const { isError, data } = await issueVouchers(activityId);
      this.isIssuing = false;
      if (isError) return;

      this.isShowIssueDialog = false;
      const failedCount = data.failed_count || 0;
      const skippedCount = data.skipped_count || 0;
      const parts = [`发放完成：成功 ${data.issued_count || 0} 人`];
      if (failedCount) parts.push(`失败 ${failedCount} 人（详见错误日志）`);
      if (skippedCount) parts.push(`跳过 ${skippedCount} 人（所在等级未配置代金券）`);
      const message = `${parts.join('，')}。`;
      this.$message({ message, type: failedCount ? 'warning' : 'success', duration: 6000 });
      this.load();
    },
    setXlsData(list) {
      return list.map((item) => ({
        '上课次数': item.total_hours || 0,
        '学员': item.student_name,
        '手机号': item.phone,
        '会员卡号': item.card_number,
        '等级': item.level_name || '--',
        '最常上课门店': item.top_store_name,
        '最常门店上课次数': item.top_store_hours || 0,
        '发券状态': item.voucher_issue_time ? '已发放' : '未发放',
        '注册时间': timeToYmdHi(item.add_time),
      }));
    },
  },
};
</script>

<style scoped>
.activity-summary {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 16px;
  row-gap: 8px;
  padding: 14px 0 10px;
}
.activity-title {
  font-size: 16px;
  font-weight: 600;
}
.refresh-time {
  font-size: 13px;
  white-space: nowrap;
}
.level-counts {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 4px 0 16px;
}
.level-count-item {
  display: flex;
  align-items: center;
  padding: 7px 14px;
  border: 1px solid #ebeef5;
  border-radius: 18px;
  background: #f5f7fa;
  font-size: 13px;
  color: #606266;
  cursor: pointer;
  transition: border-color .2s ease, background-color .2s ease, color .2s ease;
}
.level-count-item:hover {
  border-color: var(--primary-color, #ad8537);
  color: #303133;
}
.level-count-active {
  border-color: #ad8537;
  background: rgba(173, 133, 55, 0.08);
  color: #ad8537;
}
.level-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 8px;
}
.level-count-name {
  margin-right: 8px;
  font-weight: 600;
}
.issue-preview {
  padding-top: 4px;
}
.issue-summary {
  margin: 0 0 14px;
  line-height: 1.6;
}
.issue-table {
  margin-bottom: 16px;
}
.issue-warning {
  margin-top: 16px;
}
.issue-voucher-name {
  margin-left: 6px;
}
</style>
